document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);

  const product = params.get('product') || '';
  const formType = (params.get('form_type') || 'general').toLowerCase();
  const productUrl = params.get('product_url') || '';
  const productImage = params.get('product_image') || '';

  const hiddenProductField = document.getElementById('enquiry-product-name');
  const hiddenFormTypeField = document.getElementById('enquiry-form-type');
  const hiddenProductUrlField = document.getElementById('enquiry-product-url');
  const hiddenProductImageField = document.getElementById('enquiry-product-image-hidden');

  const visibleProductField = document.getElementById('VisibleProductName');
  const dynamicFieldsWrap = document.getElementById('dynamic-form-fields');

  const productMediaWrap = document.getElementById('product-enquiry-product-media');
  const productImageEl = document.getElementById('product-enquiry-product-image');
  const productTitleEl = document.getElementById('product-enquiry-product-title');

  if (hiddenProductField) hiddenProductField.value = product;
  if (hiddenFormTypeField) hiddenFormTypeField.value = formType;
  if (hiddenProductUrlField) hiddenProductUrlField.value = productUrl;
  if (hiddenProductImageField) hiddenProductImageField.value = productImage;
  if (visibleProductField) visibleProductField.value = product;

  if (productMediaWrap && productImageEl && productImage) {
    productImageEl.src = productImage;
    productImageEl.alt = product || 'Selected product';
    if (productTitleEl) productTitleEl.textContent = product;
    productMediaWrap.style.display = 'block';
  }

  function renderFields(type) {
    if (!dynamicFieldsWrap) return;

    let html = '';

    switch (type) {
      case 'desk':
        html = `
          <div class="form-row">
            <label for="DeskLength">Desk Length (mm)</label>
            <input type="number" id="DeskLength" name="contact[Desk Length]" min="1">
          </div>
          <div class="form-row">
            <label for="DeskDepth">Desk Depth (mm)</label>
            <input type="number" id="DeskDepth" name="contact[Desk Depth]" min="1">
          </div>
          <div class="form-row">
            <label for="DeskFinish">Preferred Finish</label>
            <input type="text" id="DeskFinish" name="contact[Preferred Finish]">
          </div>
        `;
        break;

      case 'screen':
        html = `
          <div class="form-row">
            <label for="ScreenWidth">Screen Width (mm)</label>
            <input type="number" id="ScreenWidth" name="contact[Screen Width]" min="1">
          </div>
          <div class="form-row">
            <label for="ScreenHeight">Screen Height (mm)</label>
            <input type="number" id="ScreenHeight" name="contact[Screen Height]" min="1">
          </div>
          <div class="form-row">
            <label for="ScreenColour">Screen Colour</label>
            <select id="ScreenColour" name="contact[Screen Colour]">
              <option value="">Select a colour</option>
              <option value="Charcoal">Charcoal</option>
              <option value="Light Grey">Light Grey</option>
              <option value="Navy">Navy</option>
              <option value="Beige">Beige</option>
            </select>
          </div>
        `;
        break;

      case 'acoustic':
        html = `
          <div class="form-row">
            <label for="RoomType">Room Type</label>
            <input type="text" id="RoomType" name="contact[Room Type]">
          </div>
          <div class="form-row">
            <label for="WallArea">Approx. Area (sqm)</label>
            <input type="text" id="WallArea" name="contact[Approx. Area]">
          </div>
          <div class="form-row">
            <label for="InstallType">Installation Type</label>
            <select id="InstallType" name="contact[Installation Type]">
              <option value="">Select installation type</option>
              <option value="Wall mounted">Wall mounted</option>
              <option value="Ceiling mounted">Ceiling mounted</option>
              <option value="Suspended">Suspended</option>
              <option value="Unsure">Unsure</option>
            </select>
          </div>
        `;
        break;

      default:
        html = `
          <div class="form-row">
            <label for="RequestType">Request Type</label>
            <input type="text" id="RequestType" name="contact[Request Type]">
          </div>
        `;
        break;
    }

    dynamicFieldsWrap.innerHTML = html;
  }

  renderFields(formType);
});